module.exports = __webpack_public_path__ + "img/triangle.a9500e07.svg";